require("!!/var/www/html/scora.io/frontend/scorauser/node_modules/script-loader/addScript.js")(require("!!/var/www/html/scora.io/frontend/scorauser/node_modules/raw-loader/index.js!/var/www/html/scora.io/frontend/scorauser/node_modules/split.js/split.js"))


//////////////////
// WEBPACK FOOTER
// ./~/script-loader!./~/split.js/split.js
// module id = 596
// module chunks = 8